import ACTIONS_REPORT_RECIPIENT from '../_constants/reportRecipient.constants';

const initialState = {
  byId: {},
};

export function reportRecipientReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_REPORT_RECIPIENT.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_REPORT_RECIPIENT.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_REPORT_RECIPIENT.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default reportRecipientReducer;
